import { render, staticRenderFns } from "./RouteLabel.vue?vue&type=template&id=38bdf94a&"
import script from "./RouteLabel.vue?vue&type=script&lang=js&"
export * from "./RouteLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports